class Toast {
	constructor() {
    this.hideTimeOut = null
  }
	
  init() {
    var toastNode = document.createElement("section");
    toastNode.innerHTML ='<i class="iconfont icon-success"></i><i class="iconfont icon-error"></i><span class="text"></span>';
    toastNode.id = "toastTips";
    toastNode.setAttribute("class", "toast");
    toastNode.style.display = "none";
    document.body.appendChild(toastNode);
  }

	show(text, type, duration) {
    // 确保上一次已被清空
    if (this.hideTimeOut) {
      clearTimeout(this.hideTimeOut);
      this.hideTimeOut = null;
    }
		
    if (!text) {
      console.error("Text cannot be empty!");
      return;
    }
		
    const domToastTips = document.getElementById("toastTips");
    
    if (!domToastTips) {
      console.error("ToastTips DOM inexistence!");
      return;
    }
		
    const domIconSuccess = domToastTips.querySelector(".icon-success");
    const domIconError = domToastTips.querySelector(".icon-error");
    const domToastText = domToastTips.querySelector(".text");
		
    domToastText.innerHTML = text || "";
		
    // type不传则不展示icon
    switch (type) {
      case "success":
        domIconSuccess.style.display = "inline-block";
        domIconError.style.display = "none";
        break;
      case "error":
        domIconSuccess.style.display = "none";
        domIconError.style.display = "inline-block";
        break;
      default:
        domIconSuccess.style.display = "none";
        domIconError.style.display = "none";
        break;
    }
		
    domToastTips.style.display = "block";
		
    const that = this;
    this.hideTimeOut = setTimeout(function () {
      domToastTips.style.display = "none";
      that.hideTimeOut = null;
    }, duration || 2000);
  }

	hide() {
    if (this.hideTimeOut) {
      clearTimeout(this.hideTimeOut);
      this.hideTimeOut = null;
    }
		
    const domToastTips = document.getElementById("toastTips");
    if (domToastTips) {
      domToastTips.style.display = "none";
      document.body.removeChild(domToastTips);
    }
  }
}